import React from 'react';
import PropTypes from 'prop-types';
import { CommentTextArea } from '../elements-comment/comment-textarea';
import { CommentPanel } from '../elements-comment/comment-panel';
import { Spinner } from 'shared-components/decorators/spinner';
import _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';

class CommentContainer extends React.Component {
  componentDidUpdate () {
    if (this.props.newComment && this.props.comments) {
      this.commentsEnd.scrollIntoView({ behavior: 'smooth' });
    }
  }

  render () {
    const collabIndex = _.keyBy(this.props.collaborators, 'value');
    const { comments, commentsToShow, hiddenComments, getFullComments, spinner } = this.props;
    const totalComments = comments ? comments.length : null;
    return (
      <div className="comment-panel-container">
        <div className="comment-header d-xs-none d-md-block">
          <span className="h6" style={{ paddingLeft: '16px' }}>
            <FormattedMessage id="boards.comment_containerboards.comment_container.comments" defaultMessage="Comments" />&nbsp;
          </span>
          <span className="comment-count">{`(${comments ? comments.length : 0})`}</span>
        </div>
        <div className="all-comments">
          { spinner ?
            <ul className="list-inline text-center v-center spinner-container">
              <li className="v-center"><Spinner /></li>
            </ul>
            : !totalComments ?
              <div className="empty-comment-container">
                <div className="empty-comment-panel">
                  <i className="ico ico-md icon-messages" />
                  <p>
                    <FormattedMessage
                      id="boards.comment_container.be_first"
                      defaultMessage="Be the first to comment on this space."
                    />
                  </p>
                </div>
              </div> :
              3 < totalComments ?
                <div className="toggle-comments">
                  <a className="v-center" onClick={getFullComments}>
                    { 0 === hiddenComments
                      ? this.props.intl.formatMessage({ id: 'boards.comment_container.hide_comments', defaultMessage: 'Hide Comments' })
                      : this.props.intl.formatMessage({ id: 'boards.comment_container.all_comments', defaultMessage: 'See all comments ({comments} more)' }, { comments: hiddenComments })
                    }
                  </a>
                </div> : <div className="see-comments-container" />
          }
          { totalComments ? commentsToShow.map((comment, i) => {
            return (
              <CommentPanel key={i} commentNumber={i} {...collabIndex[comment.created_by_sso_id]} {...comment} />
            );
          })
            : '' }
          <div ref={(el) => { this.commentsEnd = el; }} style={{ paddingTop: '12px' }} />
        </div>
        <CommentTextArea {...this.props} />
      </div>
    );
  }
}

CommentContainer.propTypes = {
  comments: PropTypes.array,
  collaborators: PropTypes.array,
  commentsToShow: PropTypes.array,
  hiddenComments: PropTypes.number,
  getFullComments: PropTypes.func,
  newComment: PropTypes.bool,
  spinner: PropTypes.bool
};

exports.CommentContainer = injectIntl(CommentContainer);
